module.exports = __webpack_public_path__ + "img/img_04.575a22db.png";